import { Box, Button } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import useAlias from '@src/hooks/useAlias';
import React from 'react';
import { useFields, useSettings } from '../hooks';
import { useFormOperations } from '../hooks/useFormOperations';

const ActionButtons: React.FC = () => {
  const alias = useAlias();
  const { showAddField, toggleAddField } = useFields();
  const { showAddSetting, toggleAddSetting } = useSettings();
  const { unsavedSettings } = useFormOperations();

  return (
    <Grid2
      container
      justifyContent='space-between'
      alignItems='center'
      size={12}
      sx={{ mt: 2 }}
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant='outlined'
          color='primary'
          onClick={toggleAddField}
          disabled={
            !showAddField && (!unsavedSettings || unsavedSettings.length === 0)
          }
          title={
            !unsavedSettings || unsavedSettings.length === 0
              ? alias('Add settings first before adding fields')
              : ''
          }
        >
          {showAddField ? alias('Cancel Add Field') : alias('Add Field')}
        </Button>
        <Button variant='outlined' color='primary' onClick={toggleAddSetting}>
          {showAddSetting ? alias('Cancel Add Setting') : alias('Add Setting')}
        </Button>
      </Box>
    </Grid2>
  );
};

export default ActionButtons;
